<template>
  <v-select
    :label="$t('report_reasons')"
    item-text="name"
    item-value="code"
    multiple
    chips
    solo
    clearable
    hide-selected
    :required="required"
    :items="default_tags"
    v-model="data"
  >
    <template slot="selection" slot-scope="data">
      <v-tooltip top>
        <v-chip
          slot="activator"
          close
          outline color="red lighten-1"
          @input="data.parent.selectItem(data.item)"
          :selected="data.selected"
          class="chip--select-multi"
          :key="JSON.stringify(data.item)"
        >
          <img :src="data.item.icon" :alt="data.item.icon_text" width="24px">
        </v-chip>
        <span>{{getTagName(data.item.code)}}</span>
      </v-tooltip>
    </template>
    <!-- Data items. -->
    <template slot="item" slot-scope="data">
      <img :src="data.item.icon" :alt="data.item.icon_text" width="24px" class="mr-3">
      {{ $t("tag_" + data.item.code) }}
    </template>
  </v-select>
</template>

<script>
import * as utils from '../../utils'
import { TAGS } from '../../utils/lookups'

export default {
  props: {
    tags: {
      default: [],
      required: true
    },
    required: {
      default: false
    }
  },

  data () {
    return {
      data: [],
      default_tags: []
    }
  },

  mounted () {
    TAGS.forEach((value, key, map) => {
      this.default_tags.push({ code: key, icon_text: value.icon_text, icon: this.getTagIconUrl(key) })
    })
  },

  watch: {
    tags (value) {
      this.data = value
    },
    data (value) {
      this.$emit('update:tags', value)
    }
  },

  methods: {
    getTagName (code) {
      return utils.getTagName(this, code)
    },

    getTagIconUrl (code) {
      return utils.getTagIconUrl(code)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/components/TagReasonSelect.vue